
import Vue, { PropType } from 'vue';
import Card from '@/components/cards/Card.vue';
import { formatDate } from '@/helpers/date';
import { Live } from '@/models/kingslanding/studyPlanModel';
import moment from 'moment';
import { isMobileDevice } from '@/helpers/mobile';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { isSourceTypeValid } from '@/helpers/lives';

export default Vue.extend({
  components: {
    Card,
  },
  props: {
    activity: {
      required: true,
      type: Object as PropType<Live>,
    },
  },
  computed: {
    live(): Live {
      return this.activity;
    },
    cover(): string {
      return this.live?.event?.avatarUrl || '';
    },
    title(): string {
      return this.live?.event?.name || '';
    },
    end(): Date {
      if (this.live.end) {
        return this.live.end;
      }

      return moment(this.live.start).add(1, 'hour').toDate();
    },
    liveTime(): string {
      if (!this.live) return '';

      const startTime = formatDate(this.live.start, 'HH:mm');
      const endTime = formatDate(this.end, 'HH:mm');

      return `${startTime} - ${endTime}`;
    },
  },
  methods: {
    trackingStudyPlanInteracted(): void {
      Analytics.trackEvent(EVENT_LABELS.studyPlanInteracted, {
        interaction_type: 'Study Plan Content Clicked',
        content_type: 'Tutoria',
      });
    },
    goToLive(): void {
      const { classroom, event } = this.live;

      if (!event || !isSourceTypeValid(event.sourceType)) {
        return;
      }

      const classroomSlug: string = classroom.slug;

      this.trackingStudyPlanInteracted();

      if (event.sourceType === 'Zoom' && isMobileDevice()) {
        window.open(event.url);
        return;
      }

      this.$router.push({
        name: 'live',
        params: {
          classroomSlug,
          liveId: event.id.toString(),
        },
      });
    },
  },
});
